import { createAiPromptRequest } from '../../../../ai-insights/aiInsightsTypes';
import { transactionActionExecutionProfiles } from '../../executionProfiles';
import type { TransactionActionRunnerOutput } from '../../proposalTypes';
import type { TransactionActionRunner } from '../../runners';
import { cleanupTransactionPrompt } from './prompt';

const CLEANUP_TRANSACTION_AGENT_ID = 'ai-insights-v2';

export const cleanupTransactionStructuredModelRunner: TransactionActionRunner = {
  id: 'structured_model',
  buildOutput({ batch }): TransactionActionRunnerOutput {
    // Single-transaction only for now, unlike every other capability here - a batch (or
    // empty) eligible set means no output.
    if (batch.capability !== 'cleanup_transaction' || batch.eligibleTransactions.length !== 1) {
      return null;
    }

    const transaction = batch.eligibleTransactions[0];
    const profile = transactionActionExecutionProfiles.cleanup_transaction;

    return {
      transport: 'structured_model',
      request: createAiPromptRequest({
        userPrompt: { text: cleanupTransactionPrompt.prompt },
        agent: CLEANUP_TRANSACTION_AGENT_ID,
        context: {
          text: cleanupTransactionPrompt.contextPrefix,
          data: {
            transaction,
            allowedCategories: transaction.allowedCategories,
            allowedTags: transaction.allowedTags,
          },
        },
        outputSchema: cleanupTransactionPrompt.schema.schema,
        options: {
          model: profile.model,
          temperature: profile.temperature,
          maxOutputTokens: profile.maxOutputTokens,
        },
      }),
    };
  },
};
